import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LEARN_TOPICS } from '@/learn';

export function LearnPage() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace(/^#/, '');
    if (!hash) return;
    const target = document.getElementById(hash);
    target?.scrollIntoView();
  }, [location.hash]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Learn</h1>
        <p className="text-sm text-gray-500 mt-1">
          How the trades in Steward work, in plain words. Each Explain panel on a position links here.
        </p>
      </div>

      <div data-testid="learn-intro" className="rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-2">
        <h2 className="text-sm font-semibold text-gray-900">Start here</h2>
        <p className="text-sm text-gray-600">
          The first five sections build up from nothing: what an option is, what calls and puts do,
          what changes when you sell one instead of buying it, how two legs become a spread — which
          is what the iron condor is made of — and how to read a risk graph, the picture of how a
          position pays off at every price. Read them in order once and the rest of this page is
          about positions you already understand.
        </p>
        <p className="text-sm text-gray-600">
          The examples of buyers and sellers, and the lessons behind them, are Howard's.
        </p>
      </div>

      {LEARN_TOPICS.map((topic) => (
        <section key={topic.id} id={topic.id} className="space-y-2">
          <h2 data-testid="learn-title" className="text-lg font-semibold text-gray-900">
            {topic.title}
          </h2>
          <p className="text-gray-500">{topic.summary}</p>
          {topic.body.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </section>
      ))}
    </div>
  );
}
